import { Loader2 } from "lucide-react";
import { Button } from "@/frontend/components/ui/button";
import type { AuthorizeStepProps } from "@/frontend/types/synthetic-hospital";

/** Step 2 of the Synthetic Hospital login. Shows requested scopes with Deny / Approve buttons that mirror the SMART Health IT launcher's authorize page. */
export function AuthorizeStep({ samplePatient, submitting, onApprove, onDeny }: AuthorizeStepProps) {
  return (
    <div className="rounded-xl border bg-card p-6 shadow-sm">
      <h2 className="text-lg font-semibold mb-4">Authorize App Launch</h2>

      {samplePatient && (
        <p className="text-sm text-muted-foreground mb-3">
          Signing in as <span className="font-medium text-foreground">{samplePatient.displayName}</span>.
        </p>
      )}

      <p className="text-sm mb-2">This application is requesting permission to:</p>
      <ul className="text-sm space-y-1 mb-6">
        <li className="flex items-start gap-2">
          <span className="text-emerald-600 mt-0.5">✓</span>
          <span><span className="font-medium">Read</span> your profile information</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-emerald-600 mt-0.5">✓</span>
          <span><span className="font-medium">Read</span> all data about the selected patient</span>
        </li>
        <li className="flex items-start gap-2">
          <span className="text-emerald-600 mt-0.5">✓</span>
          <span><span className="font-medium">Read</span> your medical information</span>
        </li>
      </ul>

      <div className="flex justify-end gap-2 pt-4 border-t">
        <Button
          type="button"
          onClick={onDeny}
          disabled={submitting !== null}
          className="bg-red-500 hover:bg-red-600 text-white"
        >
          {submitting === "deny" && <Loader2 className="size-3.5 animate-spin mr-1" />}
          Deny
        </Button>
        <Button
          type="button"
          onClick={onApprove}
          disabled={submitting !== null}
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
        >
          {submitting === "approve" && <Loader2 className="size-3.5 animate-spin mr-1" />}
          Approve
        </Button>
      </div>
    </div>
  );
}
